export const defaultTweetIds = [
  "1314834066471112704",
  "1314852223667580928",
  "1314481303388073985",
  "1314834066471112704",
  "1314742875628937216",
  "1314828495290347520",
  "1314687053918081026",
  "1314569903156887553",
  "1314837490113622018",
  "1314754799057997826",
  "1314700045300772864",
  "1314709249692512257",
  "1314535242582183937",
  "1314862548131475456",
  "1314862947861225472",
  "1314613017494138880",
  "1314438393825239040",
  "1314498136300228611",
  "1314549754823684097",
  "1314514847673929728",
  "1314602252963905538",
  "1314496753027239937",
  "1314440263054565376",
];
